// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"cf5d448d","274":"6442a682","336":"a03e3333","635":"6f758713","825":"f9cd7ee7","941":"e5af538e"}[chunkId] + ".chunk.css";
};